import { FC } from "react";
import { BreakableName } from "../../../helper/general/methods";

interface ForgeIconProps {
  forgeName: string;
  isSelected: boolean;
  onClick: () => void;
}

const ForgeIcon: FC<ForgeIconProps> = ({ forgeName, isSelected, onClick }) => {
  return (
    <div
      className={isSelected ? "selectedItem" : "unSelectedItem"}
      onClick={onClick}
    >
      <img
        className="icon-big"
        src="assets/icons/forge.png"
        draggable="false"
        alt={forgeName}
      />
      <span title={forgeName}>{BreakableName(forgeName)}</span>
    </div>
  );
};

export default ForgeIcon;
